<template>
    <div>
        <div class="vx-row">
            <div class="vx-col w-full md:w-1/2 mb-base">
                <vx-card title="Cash Out Overview">
                    <template slot="actions">
                        <feather-icon icon="DollarSignIcon" svgClasses="w-6 h-6 text-grey"/>
                    </template>

                    <template slot="no-body">
                        <div class="mt-10">
                            <vue-apex-charts type="radialBar" height="200" :options="cashOutChartOptions"
                                             :series="cashOutProgress"/>
                        </div>
                    </template>

                    <div class="flex justify-between text-center mt-6" slot="no-body-bottom">
                        <div
                            class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0">
                            <p class="mt-4">Balance</p>
                            <p class="mb-4 text-3xl font-semibold">{{balance + ' ' + currency}}</p>
                        </div>
                        <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0">
                            <p class="mt-4">Minimum Required</p>
                            <p class="mb-4 text-3xl font-semibold">{{cashOutMinimum + ' ' + currency}}</p>
                        </div>
                    </div>
                </vx-card>
            </div>

            <div class="vx-col w-full md:w-1/2 mb-base" v-if="balance > 99">
                <vx-card title="Request withdrawal">
                    <div class="flex text-center" id="withdrawalAmountWrapper">
                        <!--                        <vs-input class="w-1/4 mr-6" size="large" placeholder="Withdrawal amount"-->
                        <!--                                  v-model="withdrawalAmount"/>-->
                        <vs-input-number min="100" :max="balance" :step="10" class="mr-6 ok" v-model="withdrawalAmount"
                                         :label="currency"/>
                        <!--                        <vs-button color="primary" type="filled">Send request</vs-button>-->
                        <vs-button v-on:click="requestWithdrawal">Send request</vs-button>
                        <div class="ml-3">{{responseMsg}}</div>
                    </div>
                </vx-card>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-full mb-base">
                <div class="vx-card">
                    <div class="vx-card__header">
                        <div class="vx-card__title">
                            <h4 class="pb-4">Pending withdrawal requests</h4>
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col mb-base">
                            <vs-input id="search-box" v-on:input="filterChanged" icon="search" size="large"
                                      v-model="searchInput"
                                      label-placeholder="Search"
                                      class="ml-6 mt-6"/>
                        </div>
                        <div class="vx-col mb-base grid-filter-icon-wrapper" v-on:click="showFilters = !showFilters">
                            <feather-icon icon="FilterIcon" svgClasses="w-6 h-6 mt-6"/>
                        </div>
                    </div>
                    <div class="vx-row ag-grid-columns-filter-wrapper" v-bind:class="{ show: showFilters}">
                        <div class="vx-col ml-6">
                            <span v-for="(column, index) in columnsFilter" v-bind:key="index"
                                  class="filter-checkbox-wrapper mb-2">
                                <vs-checkbox v-model="column.show"
                                             @change="setColumnsVisibility()">{{column.name}}</vs-checkbox>
                            </span>
                        </div>
                    </div>
                    <ag-grid-vue
                        class="ag-theme-material w-100 my-4 ag-grid-table"
                        :columnDefs="pendingListColumns"
                        :rowData="getRequests"
                        :defaultColDef="defaultColDef"
                        :gridOptions="gridOptions"
                        rowSelection="multiple"
                        colResizeDefault="shift"
                        :animateRows="true"
                        :pagination="true"
                        :paginationPageSize="paginationPageSize"
                        :suppressPaginationPanel="true"
                        overlayNoRowsTemplate=" "
                        v-on:gridReady="setGridSize($event)">
                    </ag-grid-vue>
                    <vs-pagination
                        :total="totalPages"
                        :max="paginationMaxSize"
                        v-model="currentPage"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import RestService from '../services/RestService';
    import StatisticsCardLine from '../components/statistics-cards/StatisticsCardLine';
    import VueApexCharts from 'vue-apexcharts';
    import CellRendererDate from './cell-renderer/CellRendererDate';
    import CellRendererValue from './cell-renderer/CellRendererValue';
    import {AgGridVue} from 'ag-grid-vue';
    import '../assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';

    export default {
        name: "withdrawal",
        components: {
            StatisticsCardLine,
            VueApexCharts,
            AgGridVue,
            CellRendererDate,
            CellRendererValue
        },
        async beforeMount() {
            const balanceResponse = await RestService.getUserBalance();
            if (balanceResponse.success)
                this.balance = balanceResponse.data.balance;

            const pendingRequestsResponse = await RestService.requestPending();
            if (pendingRequestsResponse.success) {
                this.pendingList = pendingRequestsResponse.data;
            }

            const responseMinWithdraw = await RestService.getMinWithdraw();
            if (responseMinWithdraw.success) {
                this.cashOutMinimum = responseMinWithdraw.data.value;
            }

            if (this.balance > this.cashOutMinimum)
                this.cashOutProgress = [100];
            else
                this.cashOutProgress = [Math.round(((this.balance / this.cashOutMinimum * 100) + Number.EPSILON) * 100) / 100];
        },
        computed: {
            getRequests() {
                return this.pendingList;
            },
            paginationPageSize() {
                return 10; // TODO maybe change
            },
            paginationMaxSize() {
                if (this.gridApi) {
                    let pagesNr = this.gridApi.paginationGetTotalPages();
                    return pagesNr < 8 ? pagesNr + 1 : 7; // TODO maybe change this
                } else
                    return 1;
            },
            totalPages() {
                if (this.gridApi)
                    return this.gridApi.paginationGetTotalPages();
                else
                    return 0;
            },
            currentPage: {
                get() {
                    if (this.gridApi)
                        return this.gridApi.paginationGetCurrentPage() + 1;
                    else
                        return 1;
                },
                set(val) {
                    this.gridApi.paginationGoToPage(val - 1);
                }
            },
            currency() {
                return this.$store.state.currency;
            }
        },
        mounted() {
            this.gridApi = this.gridOptions.api;
            this.columnsFilter = this.pendingListColumns.map(c => {
                return {id: c.field, name: c.headerName, show: true};
            });
        },
        data() {
            return {
                balance: 0,
                pendingList: null,
                withdrawalAmount: 100,
                responseMsg: '',
                gridOptions: {},
                gridApi: null,
                pendingListColumns: [
                    {
                        headerName: 'Value',
                        field: 'value',
                        cellRendererFramework: 'CellRendererValue'
                    },
                    {
                        headerName: 'Description',
                        field: 'description',
                        //width: 300
                    },
                    {
                        headerName: 'Created at',
                        field: 'created_at',
                        cellRendererFramework: 'CellRendererDate',
                        //width: 300
                    },
                ],
                defaultColDef: {
                    sortable: true,
                    editable: false,
                    resizable: true,
                    suppressMenu: true
                },
                columnsFilter: [],
                showFilters: false,
                searchInput: '',
                cashOutMinimum: 0,
                cashOutProgress: [0],
                cashOutChartOptions: {
                    plotOptions: {
                        radialBar: {
                            size: 110,
                            startAngle: -150,
                            endAngle: 150,
                            hollow: {
                                size: '77%'
                            },
                            track: {
                                background: '#bfc5cc',
                                strokeWidth: '50%'
                            },
                            dataLabels: {
                                name: {
                                    show: false
                                },
                                value: {
                                    offsetY: 18,
                                    color: '#99a2ac',
                                    fontSize: '4rem'
                                }
                            }
                        }
                    },
                    colors: ['#00db89'],
                    fill: {
                        type: 'gradient',
                        gradient: {
                            shade: 'dark',
                            type: 'horizontal',
                            shadeIntensity: 0.5,
                            gradientToColors: ['#00b5b5'],
                            inverseColors: true,
                            opacityFrom: 1,
                            opacityTo: 1,
                            stops: [0, 100]
                        }
                    },
                    stroke: {
                        lineCap: 'round'
                    },
                    chart: {
                        sparkline: {
                            enabled: true
                        },
                        dropShadow: {
                            enabled: true,
                            blur: 3,
                            left: 1,
                            top: 1,
                            opacity: 0.1
                        }
                    }
                }
            }
        },
        methods: {
            async requestWithdrawal() {
                const requestWithdrawalResponse = await RestService.requestWithdrawal(this.withdrawalAmount);
                if (requestWithdrawalResponse.success) {
                    //this.responseMsg = 'Request was successfully sent.';
                    const pendingRequestsResponse = await RestService.requestPending();
                    if (pendingRequestsResponse.success) {
                        this.pendingList = pendingRequestsResponse.data;
                    }
                } else {
                    // this.responseMsg = 'Request cannot be sent.';
                    this.$vs.notify({
                        color: 'danger',
                        title: 'ERROR',
                        text: 'Request cannot be sent.',
                        position: 'top-right'
                    });
                }
            },

            setGridSize(params) {
                if (window.innerWidth > 1024)
                    params.api.sizeColumnsToFit();
                this.gridOptions.api.setDomLayout('autoHeight');
            },

            filterChanged() {
                this.gridApi.setQuickFilter(document.getElementById('search-box').value);
            },

            setColumnsVisibility() {
                this.columnsFilter.forEach(c => {
                    this.gridOptions.columnApi.setColumnVisible(c.id, c.show);
                });
                // TODO this needs optimization
                if (window.innerWidth > 1024)
                    this.gridApi.sizeColumnsToFit();
            }
        }
    }
</script>

<style>
    #withdrawalAmountWrapper .vs-input-number--button-less,
    #withdrawalAmountWrapper .vs-input-number--button-plus {
        padding: 8px;
    }

    #withdrawalAmountWrapper .vs-input-number .limit .vs-icon {
        font-size: 18px;
        font-weight: 900;
    }

    #withdrawalAmountWrapper .vs-input-number span {
        position: absolute;
        font-size: 20px;
        left: 45px;
        z-index: 5;
    }

    #withdrawalAmountWrapper .vs-input-number--input {
        width: 130px !important;
        font-size: 24px;
        text-align: right !important;
        padding: 5px 14px;
        border-radius: 8px;
    }

    #withdrawalAmountWrapper .vs-button {
        align-self: center !important;
    }
</style>
